// Temporarily hardcoded for local development
// export const API_BASE_URL = 'http://localhost:5000';
// export const WS_URL = 'http://localhost:5000';

// Original code (re-enable after testing):
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";
export const WS_URL = process.env.REACT_APP_WS_URL || "http://localhost:5000";
